<template>
  <div>
    <swatches show-fallback
              class="inline-block"
              inline
              row-length="6"
              shapes="circles"
              show-border
              popover-x="left"
              v-model="colorInline"
    />
    <swatches show-fallback
              class="inline-block"
              inline
              row-length="6"
              shapes="circles"
              show-border
              popover-x="left"
              v-model="colorPopup"
    />
  </div>

</template>

<script>
  import Swatches from 'vue-swatches'
  export default {
    name: "colorPicker",
    components: {
      Swatches
    },
    data() {
      return {
        colorInline: '',
        colorPopup: ''
      }
    }
  }
</script>

<style scoped>

</style>
